import { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";
import useUserData from "@hooks/useUserData";
import { toast } from "sonner";

export default function AdmRootPage() {
  const [stats, setStats] = useState<any>({});
  const { userData } = useUserData();

  const referralCode = userData?.uuid || userData?.id;
  const referralLink = `${window.location.origin}/?ref=${referralCode ?? ''}`;

  const handleCopyReferral = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      toast.success('Ссылка скопирована в буфер обмена');
    } catch (error) {
      toast.error('Не удалось скопировать ссылку');
    }
  }, [referralLink]);
      
  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_URL}/user/referral/stats`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        }
      })
      .then(response  => {
        setStats(response.data);
      })
      .catch(error => {
        setStats({
            registrations: 0,
            payments: 0,
            bonus: 0,
        });
      });
  }, [userData]);


  const formatNumber = (num: any) => {
    if (num == null) return '0';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  return (
    <MainContent>    
        <SEO 
            title="Партнерская программа"
            description=""
            ogUrl="https://artcons.io/"
        />

        <div className={css.head}>
            <h1>Партнерская программа</h1>
            <span>Расскажите о&nbsp;АртКонс друзьям и&nbsp;партнёрам&nbsp;— получайте 10% от всех пополнений ими целых 3&nbsp;месяца!</span>
        </div>

        <div className={css.referral}>
            <div className={css.referralText}>
                <h2>Ваша реферальная ссылка</h2>
                <span>Поделитесь ссылкой с коллегами и партнёрами, чтобы получать вознаграждение за клиента</span>
            </div>

            <div className={css.referralField}>
                <div className={css.referralInputWrapper}>
                    <input
                        type="text"
                        readOnly
                        value={referralLink}
                        onFocus={(e) => e.target.select()}
                    />
                    <button
                        type="button"
                        className={css.referralCopy}
                        onClick={handleCopyReferral}
                    >
                        <i className="fi fi-rr-copy"></i>
                    </button>
                </div>

                <div className={css.referralShare}>
                    <button
                        type="button"
                        className={`${css.referralShareBtn} ${css.whatsapp}`}
                        onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(referralLink)}`, '_blank')}
                    >
                        <i className="fi fi-brands-whatsapp"></i>
                    </button>

                    <button
                        type="button"
                        className={`${css.referralShareBtn} ${css.vk}`}
                        onClick={() => window.open(`https://vk.com/share.php?url=${encodeURIComponent(referralLink)}`, '_blank')}
                    >
                        <i className="fi fi-brands-vk"></i>
                    </button>
                </div>
            </div>
        </div>

        <div className={css.referral} style={{ marginTop: -10 }}>
            <div className={css.referralText}>
                <h2>Агентская программа</h2>
                <span>Зарабатывайте в течение всего жизненного цикла приглашенного клиента.</span>

                <Link to={`/support`} className={css.referralLink}>Связаться с нами</Link>
            </div>
        </div>

        {stats?.bonus > 0 &&
            <div className={css.referral} style={{ marginTop: -10 }}>
                <div className={css.referralText}>
                    <h2>Вывод средств</h2>
                    <span>Вы можете выводить средства с вашего баланса в любое время. Напишите нам, заявка будет обработана в течение 1 дня.</span>

                    <Link to={`/support`} className={css.referralLink}>Связаться с нами</Link>
                </div>
            </div>
        }

        <h3 className={css.h3}>Статистика по приглашенным клиентам</h3>

        <div className={css.blocks}>
            <div className={css.block}>
                <a>Регистраций</a>
                <b>{stats?.registrations}</b>
            </div>

            <div className={css.block}>
                <a>Оплат</a>
                <b>{stats?.payments}</b>
            </div>

            <div className={css.block}>
                <a>Заработано</a>
                <b>{formatNumber(stats?.bonus) || 0} ₽</b>
            </div>
        </div>
    </MainContent>
  )
}